import React from 'react'

import HomeBanner from '../components/home-banner'
import TitleContentImageBlocks from '../components/title-content-image-blocks'
import ImageSubscribe from '../components/image-subscribe'
import ImageBanner from '../components/image-banner'
import Enquiry from '../components/enquiry'
import TitleStats from '../components/title-stats'
import Roles from '../components/roles'
import Blog from '../components/blog'
import Contact from '../components/contact'
import Appraisal from '../components/appraisal'
import Quote from '../components/quote'
import LatestNews from '../components/latest-news'
import LatestCaseStudies from '../components/latest-case-studies'
import CardBlocks from '../components/card-blocks'
import AgentsHeader from '../components/agents-header'
import Agents from '../components/agents'
import PropertyArchive from '../components/property-archive'
import PropertyShowcase from '../components/property-showcase'
import Upcoming from '../components/upcoming'
import BasicPage from '../components/basic-page'
import EmergencyTrades from '../components/emergency-trades'
import OfficeMap from '../components/office-map'
import VideoBanner from '../components/video-banner'
import RegisterForAlerts from '../components/register-for-alerts'
import EmbeddableContent from '../components/embeddable-content'

const renderBlock = (param, el, i) => {
  el.key = i

  let block = {
    'HomeBanner' : (el) => <HomeBanner {...el} />,
    'TitleContentImageBlocks' : (el) => <TitleContentImageBlocks {...el} />,
    'ImageSubscribe' : (el) => <ImageSubscribe {...el} />,
    'ImageBanner' : (el) => <ImageBanner {...el} />,
    'VideoBanner' : (el) => <VideoBanner {...el} />,
    'Enquiry' : (el) => <Enquiry {...el} />,
    'TitleStats' : (el) => <TitleStats {...el} />,
    'Roles' : (el) => <Roles {...el} />,
    'Blog' : (el) => <Blog {...el} />,
    'Contact' : (el) => <Contact {...el} />,
    'RegisterForAlerts' : (el) => <RegisterForAlerts {...el} />,
    'Appraisal' : (el) => <Appraisal {...el} />,
    'Quote' : (el) => <Quote {...el} />,
    'LatestNews': (el) => <LatestNews {...el} />,
    'LatestCaseStudies': (el) => <LatestCaseStudies {...el} />,
    'CardBlocks': (el) => <CardBlocks {...el} />,
    'AgentsHeader': (el) => <AgentsHeader {...el} />,
    'Agents': (el) => <Agents {...el} />,
    'PropertyArchive': (el) => <PropertyArchive {...el} />,
    'PropertiesShowcase': (el) => <PropertyShowcase {...el} />,
    'Upcoming': (el) => <Upcoming {...el} />,
    'BasicPage': (el) => <BasicPage {...el} />,
    'EmergencyTrades': (el) => <EmergencyTrades {...el} />,
    'OfficeMap': (el) => <OfficeMap {...el} />,
    'EmbeddableContent': (el) => <EmbeddableContent {...el} />
  }[param]

  if (!block) return null

  return block(el)
}

export default renderBlock